import { useState } from "react";
import { getTopSellingItems } from "../api/dashboardApi";

const useTopSelling = () => {
  const [topSellingData, setTopSellingData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTopSelling = async () => {
    try {
      setLoading(true);
      const res = await getTopSellingItems();
      setTopSellingData(res?.data || []);
      return res;
    } catch (error) {
      console.error("error on get top selling:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    getTopSelling,
    topSellingData,
    loading,
  };
};

export default useTopSelling;
